import React from 'react';
import { motion } from 'framer-motion';
import { ExternalLink } from 'lucide-react';
const beastChannels = [{
  title: 'MrBeast',
  subtitle: 'Main Channel',
  image: 'https://cdn.magicpatterns.com/uploads/tFBcLzeMFXuuGdLPrvHKcH/channels4_profile.jpg',
  link: 'https://youtube.com/@MrBeast',
  subscribers: '340M+'
}, {
  title: 'MrBeast Gaming',
  subtitle: 'Gaming Channel',
  image: 'https://cdn.magicpatterns.com/uploads/hurA5o62tvALfpPZF23pLZ/channels4_profile(1).jpg',
  link: 'https://youtube.com/@MrBeastGaming',
  subscribers: '46M+'
}, {
  title: 'MrBeast 2',
  subtitle: 'Extra Content',
  image: 'https://cdn.magicpatterns.com/uploads/gtNvssrrN5qbrR1oY7PsEi/channels4_profile(2).jpg',
  link: 'https://youtube.com/@MrBeast2',
  subscribers: '47M+'
}, {
  title: 'Beast Reacts',
  subtitle: 'Reaction Videos',
  image: 'https://cdn.magicpatterns.com/uploads/5EkiiJMruFmB2LfXhptMW8/channels4_profile(3).jpg',
  link: 'https://youtube.com/@BeastReacts',
  subscribers: '35M+'
}, {
  title: 'Beast Philanthropy',
  subtitle: 'Changing Lives',
  image: 'https://cdn.magicpatterns.com/uploads/shQFNdFFHgrYuJwssuNq4v/channels4_profile(4).jpg',
  link: 'https://youtube.com/@BeastPhilanthropy',
  subscribers: '27M+'
}];
export function MoreBeastSection() {
  return <section className="w-full py-24 bg-[#16213e] relative overflow-hidden" data-id="element-125">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(#ffffff 1px, transparent 1px)',
      backgroundSize: '30px 30px'
    }} data-id="element-126" />

      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-127">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-128">
          <h2 className="font-oswald text-5xl md:text-7xl font-bold text-white uppercase tracking-wider mb-4" data-id="element-129">
            More <span className="text-[#ffd700]" data-id="element-130">Beast</span>
          </h2>
          <p className="text-gray-400 text-lg" data-id="element-131">
            Join the community across the internet
          </p>
        </motion.div>

        {/* Channel Cards with Images */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6" data-id="element-132">
          {beastChannels.map((channel, index) => <motion.a href={channel.link} target="_blank" rel="noopener noreferrer" key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} whileHover={{
          y: -8,
          scale: 1.02
        }} className="group relative bg-[#0f0f1a] rounded-2xl overflow-hidden border border-white/10 hover:border-[#ffd700]/50 transition-all duration-300" data-id="element-133">
              {/* Channel Image */}
              <div className="relative aspect-square overflow-hidden" data-id="element-134">
                <img src={channel.image} alt={channel.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-135" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0f0f1a] via-transparent to-transparent opacity-60" data-id="element-136" />

                {/* External Link Icon */}
                <div className="absolute top-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-137">
                  <div className="bg-[#ffd700] rounded-full p-2" data-id="element-138">
                    <ExternalLink className="w-4 h-4 text-black" data-id="element-139" />
                  </div>
                </div>
              </div>

              {/* Channel Info */}
              <div className="p-4 text-center" data-id="element-140">
                <h3 className="font-oswald text-xl font-bold text-white group-hover:text-[#ffd700] transition-colors mb-1" data-id="element-141">
                  {channel.title}
                </h3>
                <p className="text-gray-500 text-sm mb-2" data-id="element-142">{channel.subtitle}</p>
                <p className="text-[#ffd700] font-bold text-sm" data-id="element-143">
                  {channel.subscribers} subscribers
                </p>
              </div>
            </motion.a>)}
        </div>
      </div>
    </section>;
}